// src/components/ModalFinalizar.jsx

import React, { useRef, useEffect } from "react";
import styles from "../App.module.css";

const ModalFinalizar = ({
  open,
  onClose,
  onSubmit,
  login,
  setLogin,
  senha,
  setSenha,
  inputValue,
  setInputValue,
  textareaRef
}) => {
  // Expande o textarea conforme digita
  useEffect(() => {
    if (textareaRef?.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${Math.min(textareaRef.current.scrollHeight, 400)}px`;
    }
  }, [inputValue, textareaRef]);

  if (!open) return null;

  return (
    <div className={styles.modalProducao}>
      <div className={styles.modalContentProducao}>
        <h2>Conta de agendamento</h2>
        <div className={styles.containerTituloInput}>
          <input
            className={styles.inputStyleLogin}
            type="text"
            onChange={e => setLogin(e.target.value)}
            value={login}
            placeholder="Digite o Email"
          />
          <input
            className={styles.inputStyleLogin}
            type="text"
            onChange={e => setSenha(e.target.value)}
            value={senha}
            placeholder="Digite a senha"
          />
        </div>
        <h2>Observação do produtor</h2>
        <textarea
          ref={textareaRef}
          style={{ width: "100%", minHeight: "50px", maxHeight: "400px", overflow: "auto", resize: "none" }}
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
        />
        <button onClick={onSubmit}>Finalizar ds-160</button>
        <button onClick={() => { onClose(); setInputValue(""); }}>X</button>
      </div>
    </div>
  );
};

export default ModalFinalizar;
